(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function fixSlideshowAndAutoplay() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item, .swiper-slide');
      slideItems.forEach(function(slideItem) {
        const contentSlides = slideItem.querySelectorAll('.content-slide, motion-element');
        contentSlides.forEach(function(contentSlide) {
          contentSlide.style.opacity = '1';
          contentSlide.style.visibility = 'visible';
        });
      });
    });

    // Force Swiper Autoplay to continue after interaction
    const slideSections = document.querySelectorAll('slide-section');
    slideSections.forEach(function(section) {
      if (section.swiper && section.swiper.autoplay) {
        section.swiper.params.autoplay.disableOnInteraction = false;
        section.swiper.params.autoplay.pauseOnMouseEnter = false;
        section.swiper.autoplay.start();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', fixSlideshowAndAutoplay);
  window.addEventListener('load', fixSlideshowAndAutoplay);

  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', fixSlideshowAndAutoplay);
    document.addEventListener('shopify:section:deselect', fixSlideshowAndAutoplay);
    document.addEventListener('shopify:section:reorder', fixSlideshowAndAutoplay);
    document.addEventListener('shopify:block:select', fixSlideshowAndAutoplay);
    document.addEventListener('shopify:block:deselect', fixSlideshowAndAutoplay);
    document.addEventListener('shopify:section:load', fixSlideshowAndAutoplay);
  }
  } catch(e) { console.error(e); }
})();

})();
